module.exports = __webpack_public_path__ + "media/images/partners/mosbiletw-3a7991548096533d093f265fca77b63e.svg";